module.exports = __webpack_public_path__ + "static/media/mastercard.04f67188.svg";